export const getDocumentationUrl = (urlPath?: string) => {
    const typedWindow: any = window;
    return `${typedWindow.REACT_APP_CLOUDOMATION_DOCS_URL}/engine/${
        process.env.REACT_APP_VERSION_MAJOR
    }${urlPath ?? ""}`;
};
